import axios from "axios";
import {
  CleanupPanoramaResponse,
  GeneratePanoramaRequest,
  GeneratePanoramaResponse,
  PanoramaInfoResponse,
} from "../shared/panorama";
import { getUser } from "../supabaseClient";
import { getBackend } from "../utils/getBackend";
import { getAccessTokenHeader } from "./helper/getAccessTokenHeader";

export async function generatePanorama(
  request: Omit<GeneratePanoramaRequest, "userId">,
) {
  const user = await getUser();
  if (!user) {
    throw new Error("User not authenticated");
  }

  const { data } = await axios.post<GeneratePanoramaResponse>(
    getBackend() + "/tools/images/generate-panorama",
    {
      ...request,
      userId: user.id,
    },
    {
      headers: await getAccessTokenHeader(),
      timeout: 1000 * 60 * 5,
    },
  );

  return data;
}

export async function getPanoramaInfo({
  originalPath,
  feedId,
}: {
  originalPath: string;
  feedId: number;
}) {
  const user = await getUser();
  if (!user) {
    throw new Error("User not authenticated");
  }

  const { data } = await axios.post<PanoramaInfoResponse>(
    getBackend() + "/tools/images/panorama-info",
    {
      userId: user.id,
      originalPath,
      feedId,
    },
    {
      headers: await getAccessTokenHeader(),
      timeout: 1000 * 60,
    },
  );

  return data;
}

export async function cleanupPanorama(generationId: string) {
  const user = await getUser();
  if (!user) {
    throw new Error("User not authenticated");
  }

  const { data } = await axios.post<CleanupPanoramaResponse>(
    getBackend() + "/tools/images/cleanup-panorama",
    {
      userId: user.id,
      generationId,
    },
    {
      headers: await getAccessTokenHeader(),
      timeout: 1000 * 60,
    },
  );

  return data;
}
